module.exports = __webpack_public_path__ + "img/ad_3.f54c8f0f.png";